import { ProgrammeContactCard } from '@dealstack/frontend/investor/pages/Valuations/ValuationsDrawer/ProgrammeContactCard';
import { Box } from '@mantine/core';
import type { ProgrammeContactDrawerPerson } from './ProgrammeContact.types';

interface Props {
	persons: ProgrammeContactDrawerPerson[];
}

export const ProgrammeContact = (props: Props) => {
	return (
		<Box style={{ display: 'flex', gap: '1rem', flexDirection: 'column', width: '100%' }}>
			{props.persons?.map((person) => {
				return <ProgrammeContactCard key={person.mail} data={{ ...person }} />;
			})}
		</Box>
	);
};
